import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ITopologyImported } from './import/UseImportTopology';


export interface ImportTopology {
    importedTopology: ITopologyImported | null;
    fileName:string
}

export interface ParamTopologiesPagination {
    page: number;
    perPage: number;
    sort: 1 | -1 | undefined;
    search: string;
    field: string | undefined;
    env:string
}

interface TreatementState {
    importedTopology:ImportTopology
    paramTopologiesPagination:ParamTopologiesPagination
}

const initialState: TreatementState = {
    importedTopology :{
        fileName:"",
        importedTopology:null
    },
    paramTopologiesPagination: {
        page:0,
        perPage:10,
        field:'modificationDate',
        sort:-1,
        search:"",
        env:"bas,eid,prod"
    }
};


export type SettingsValues = { [key: string]: any }


export const treatmentSlice = createSlice({
    name: 'treatment',
    initialState : initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        initImportTopology: (state) => {
            state.importedTopology = initialState.importedTopology
        },
        initParamTopologyPagination: (state) => {
            state.paramTopologiesPagination = initialState.paramTopologiesPagination
        },
        setTopologyImported: (state, action: PayloadAction<ImportTopology>) => {
            state.importedTopology = action.payload
        },
        setParamTopologyPagination: (state, action: PayloadAction<ParamTopologiesPagination>) => {
            state.paramTopologiesPagination = action.payload
        },
    }


});

export const {

    setTopologyImported,
    initImportTopology,
    initParamTopologyPagination,
    setParamTopologyPagination

} = treatmentSlice.actions;

export default treatmentSlice.reducer;
